<div class="flex space-x-1">
  <ng-container *ngIf="project_data.assign_by && project_data.assign_by.length > 0">
    <penji-user-array-item [uid_array]=" project_data.assign_by"></penji-user-array-item>
    <ng-container *ngIf="reassign_on">
      <penji-project-reassign [project_data]="project_data"></penji-project-reassign>
    </ng-container>
</ng-container>
</div>
